// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.main[data-v-c6dbab20] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.title-container[data-v-c6dbab20] {\n  margin-left: 4rem;\n  margin: 2rem 0 0 3.2rem;\n}\n.title[data-v-c6dbab20] {\n  color: var(--color-grey);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
